import { NgModule } from '@angular/core';
import { ActionFeedbackComponent } from './action-feedback/action-feedback.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ExecuteActionComponent } from './execute-action/execute-action.component';

@NgModule({
  declarations: [
    ActionFeedbackComponent,
    ExecuteActionComponent,
    FooterComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  providers: [],
  exports: [],
  entryComponents: [
    ActionFeedbackComponent,
    ExecuteActionComponent,
  ],
})

export class HospitalBookingModule {}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/hospital-booking.module.ts